// extracted by mini-css-extract-plugin
export default {"container":"Header_container__uzPfY","img":"Header_img__Li3DS","headerIcon":"Header_headerIcon__t4Jai"};